import './App.css';
import logo from './logo.gif';
import uc from "./under-construction.jpg"

export default function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
      </header>
      <img src={uc} title='under construction' alt='under construction' className='UnderConstruction' />
    </div>
  );
}